module.exports = __webpack_public_path__ + "img/cloud_send.eef0d6e0.svg";